module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-logs__container",
    class: {
      'p-2': !_vm.isResume
    }
  }, [_c('div', {
    staticClass: "row mx-0 h-100",
    class: {
      'border': !_vm.isResume
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 bg-lightest d-flex flex-column"
  }, [_c('div', {
    staticClass: "tab-logs__container--root",
    class: {
      'border': _vm.isResume
    }
  }, [_c('div', {
    staticClass: "tab-logs__table-container"
  }, [_c('table', {
    staticClass: "tab-logs__table-container--table-details mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedAudits), function(audit, i) {
    return _c('tr', {
      key: _vm.auditKey(audit, i),
      staticClass: "tab-logs__table-container--table-row",
      class: {
        expanded: _vm.isOpen(i, audit)
      }
    }, [_c('td', {
      staticClass: "tabs-logs__table-user-col"
    }, [_c('div', {
      staticClass: "tabs-logs__table-user-col--wrap"
    }, [(audit.userLogo) ? _c('img', {
      staticClass: "tabs-logs__table-user-col--avatar",
      attrs: {
        "src": audit.userLogo
      }
    }) : _c('div', {
      staticClass: "tabs-logs__table-user-col--avatar"
    }, [_vm._v(_vm._s(audit.username[0]))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "tabs-logs__table-user-col--name"
    }, [_vm._v(_vm._s(audit.username || '—') + "\n                                            ")]), _vm._v(" "), _c('div', {
      staticClass: "tabs-logs__table-user-col--time"
    }, [_vm._v(_vm._s(audit.timestamp))])])])]), _vm._v(" "), _c('td', {
      staticClass: "tabs-logs__table-entry-col"
    }, [_c('div', {
      staticClass: "entry"
    }, [(audit.shouldShowMore && audit.entries && audit.entries.length) ? _c('div', {
      staticClass: "tabs-logs__table-entry-col--entry-box",
      class: {
        open: _vm.isOpen(i, audit)
      }
    }, [_c('div', {
      staticClass: "tabs-logs__table-entry-col--entry-box-header"
    }, [_c('span', {
      staticClass: "tabs-logs__title link-color",
      domProps: {
        "innerHTML": _vm._s(_vm.buildTitleHtml(audit))
      },
      on: {
        "click": _vm.onAuditClick
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "see-more",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleRow(i, audit)
        }
      }
    }, [_vm._v("\n                                                    " + _vm._s(_vm.isOpen(i, audit) ? 'close' : 'see more') + "\n                                                ")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isOpen(i, audit)),
        expression: "isOpen(i, audit)"
      }],
      staticClass: "tabs-logs__table-entry-box--content"
    }, [_c('div', {
      staticClass: "tabs-logs__table-entry-box--note darkest"
    }, _vm._l((audit.entries), function(e, idx) {
      return _c('div', {
        key: idx,
        staticClass: "note-line"
      }, [(e.property) ? _c('span', {
        staticClass: "note-prop"
      }, [_vm._v(_vm._s(e.property ||
        '') + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "note-old-val"
      }, [_vm._v(_vm._s(_vm.displayValue(e.oldValue)))]), _vm._v(" "), _c('span', {
        staticClass: "note-arrow"
      }, [_vm._v(" → ")]), _vm._v(" "), _c('span', {
        staticClass: "note-new-val"
      }, [_vm._v(_vm._s(_vm.displayValue(e.newValue)))])])
    }), 0)])]) : _c('div', {
      staticClass: "tabs-logs__table-entry-col--entry-title"
    }, [_c('span', {
      staticClass: "tabs-logs__title tabs-logs__title--no-see-more link-color",
      domProps: {
        "innerHTML": _vm._s(_vm.buildTitleHtml(audit))
      },
      on: {
        "click": _vm.onAuditClick
      }
    })])])])])
  }), 0)])]), _vm._v(" "), (_vm.totalPages > 1 && !_vm.isResume) ? _c('div', {
    staticClass: "tabs-log__pagination"
  }, [_c('button', {
    staticClass: "tabs-log__pagination-btn-page",
    attrs: {
      "disabled": _vm.page === 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._v("Previous")]), _vm._v(" "), _c('span', {
    staticClass: "tabs-log__pagination-page-info"
  }, [_vm._v("Page " + _vm._s(_vm.page) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('button', {
    staticClass: "tabs-log__pagination-btn-page",
    attrs: {
      "disabled": _vm.page === _vm.totalPages
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("Next")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "70%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a8e3c3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabLogs/TabLogs.vue
// module id = 1764
// module chunks = 0